import { getAbsoluteUrl } from "./urls";
import { fetchAuthenticated } from "./utils";
import { ERROR, FAILED, SUCCESS } from "../utils/constants/tags";

import User from "../models/user";
import Errors from "../models/errors";
import { HTTP_NO_CONTENT } from "../utils/constants/http";

export interface UsersRequestStatus {
  status: string;
  detail?: string;
  data?: {
    items: User[];
    count: number;
  };
}

export const getUsers = async (
  limit: number | undefined = undefined,
  offset: number | undefined = undefined,
  search: string | undefined = undefined,
  groupId: number | undefined = undefined
) => {
  const params = new URLSearchParams();
  if (limit !== undefined) {
    params.set("limit", limit.toString());
  }
  if (offset !== undefined) {
    params.set("offset", offset.toString());
  }

  if (search !== undefined) {
    params.set("search", search);
  }

  if (groupId !== undefined) {
    params.set("group_id", groupId.toString());
  }

  const url = getAbsoluteUrl("/users/?") + params.toString();

  let response: Response = { ok: false } as Response;
  try {
    response = await fetchAuthenticated(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
      credentials: "include",
    });
  } catch (error) {
    return {
      status: FAILED,
      detail: "Server not Found",
    };
  }
  const responseData: UsersRequestStatus = await response.json();

  return responseData;
};

export interface UserRequestStatus {
  status: string;
  detail?: string;
  data?: User;
  errors?: Errors;
}

export const createUser = async (user: User): Promise<UserRequestStatus> => {
  const url = getAbsoluteUrl("/users/create/");
  let response: Response = { ok: false } as Response;
  try {
    response = await fetchAuthenticated(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      credentials: "include",
      body: JSON.stringify(user),
    });
  } catch (error) {
    return {
      status: FAILED,
      detail: "Server not Found",
    };
  }

  const responseData: UserRequestStatus = await response.json();

  return responseData;
};

export const getUser = async (id: number): Promise<UserRequestStatus> => {
  const url = getAbsoluteUrl(`/users/${id}/`);
  let response: Response = { ok: false } as Response;
  try {
    response = await fetchAuthenticated(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
      credentials: "include",
    });
  } catch (error) {
    return {
      status: FAILED,
      detail: "Server not Found",
    };
  }

  const responseData: UserRequestStatus = await response.json();

  return responseData;
};

export const updateUser = async (user: User): Promise<UserRequestStatus> => {
  const url = getAbsoluteUrl(`/users/${user.id}/`);
  let response: Response = { ok: false } as Response;
  try {
    response = await fetchAuthenticated(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      credentials: "include",
      body: JSON.stringify(user),
    });
  } catch (error) {
    return {
      status: FAILED,
      detail: "Server not Found",
    };
  }

  const responseData: UserRequestStatus = await response.json();

  return responseData;
};

export const deleteUser = async (user: User): Promise<UserRequestStatus> => {
  const url = getAbsoluteUrl(`/users/${user.id}/`);
  let response: Response = { ok: false } as Response;
  try {
    response = await fetchAuthenticated(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "DELETE",
      credentials: "include",
      body: JSON.stringify(user),
    });
  } catch (error) {
    return {
      status: FAILED,
      detail: "Server not Found",
    };
  }

  if (response.status === HTTP_NO_CONTENT) {
    return { status: SUCCESS };
  }

  return {
    status: ERROR,
    detail: "Hubo un error eliminando la máquina. Intente de vuelta",
  };
};

export const changeUserPassword = async (
  user: User
): Promise<UserRequestStatus> => {
  const url = getAbsoluteUrl(`/users/${user.id}/reset_password/`);
  let response: Response = { ok: false } as Response;
  try {
    response = await fetchAuthenticated(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      credentials: "include",
      body: JSON.stringify(user),
    });
  } catch (error) {
    return {
      status: FAILED,
      detail: "Server not Found",
    };
  }

  const responseData: UserRequestStatus = await response.json();

  return responseData;
};
